import { APIUserPersonBinding } from '@ardoq/api-types';
import { crudApi } from './api';

export const userPersonBindingApi = crudApi<APIUserPersonBinding>(
  'user-person-binding'
);
